<script lang="ts" setup>
	import type { Breadcrumb } from '@gravity-studio/gsmaterials-nuxt/types'

	const $props = defineProps<{
		title?: string,
		breadcrumbs?: Breadcrumb[]
	}>()
	/*const breadcrumbs  = computed(() => {
		if ($props.breadcrumbs)
			return [{label: 'Startseite', to: {name: 'index'}},...$props.breadcrumbs]
		return
	})*/
</script>

<template>
	<Head>
		<Title>{{ title }}</Title>
	</Head>

	<slot name="header">
		<div class="bg-primary-50" :class="{'pt-43.25 lg:pt-52':$screen.gte.lg}">
			<GsPageSection as="div" v-if="breadcrumbs" container-class="px-4">
				<GsBreadcrumbs
					:items="breadcrumbs"
					separator-icon="mdi-slash-forward"
					class="pb-10 pt-5 sm:pt-8 -ml-9 space-x-1 xs:space-x-2 sm:space-x-3"
					separator-class="text-primary-500/70"
					link-class="text-primary hover:text-accent text-[10px] xs:text-xs sm:text-sm lg:text-md ml-1 xs:ml-2 sm:ml-3"
					text-class="text-primary text-[10px] xs:text-xs sm:text-sm lg:text-md ml-1 xs:ml-2 sm:ml-3"
				/>
			</GsPageSection>
			<div v-if="Object.keys($slots).includes('header-content')" class="pb-5 sm:pb-8 md:pb-20">
				<GsPageSection container-class="px-4">
					<div class="flex flex-col lg:flex-row" role="banner">
						<slot name="header-content" />
					</div>
				</GsPageSection>
			</div>
		</div>
	</slot>

	<slot />

</template>

<style lang="postcss" global>
	main {
		overflow: hidden
	}
	.page-enter-active,
	.page-leave-active {
		transition: all 0.15s;
	}
	.page-enter-from,
	.page-leave-to {
		opacity: 0;
		transform: scale(0.9);
		filter: blur(.5rem);
	}
	.nnf-article-card,
	.nnf-article-card__content-wrapper,
	.nnf-article-card * {
		width: 100% !important;
	}
	.nnf-article-card__content-wrapper {
		border-radius: 10px !important;
		overflow: hidden;
	}
	.nnf-article-card__headline {
		font-weight: bold !important;
	}
</style>
